import { ConfigInterface } from "@/core/config/Config.interface";

// individual environments configs:
//如果發生config檔載入型態與本身json不符，將VSCode關閉重開。
import configLocal from "@/core/config/config-files/local.json";
import configStaging from "@/core/config/config-files/staging.json";
import configProduction from "@/core/config/config-files/production.json";
import configProdStg from "@/core/config/config-files/prodstg.json";

// return appropriate config based on env VUE_APP_CONFIG
let env: string = "local"; /* by default we return the local configuration */

// if our env VUE_APP_CONFIG variable is set, get its value
if (process.env && process.env.VUE_APP_CONFIG) {
  env = process.env.VUE_APP_CONFIG.trim().toLowerCase();
}

export const configsMap: Map<string, ConfigInterface> = new Map<
  string,
  ConfigInterface
>([
  ["local", configLocal],
  ["staging", configStaging],
  ["production", configProduction],
  ["prodstg", configProdStg]
]);

if (!configsMap.has(env)) {
  throw Error(`Could not find config for VUE_APP_CONFIG key "${env}"`);
}

export const config: ConfigInterface = configsMap.get(env) as ConfigInterface;
